import React, { useState, useEffect } from "react";
import styles from "./Slider.module.scss";

export default function Slider(props) {
  const [value, setValue] = useState(props.defaultData);

  // Обновляем состояние слайдера, если props.settings изменяется
  useEffect(() => {
    if (props.settings && props.settings[props.value] !== undefined) {
      setValue(String(props.settings[props.value]));
    }
  }, [props.settings, props.value]);

  const handlerOnInput = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    props.sliderObserver(newValue, props.value); // Передаем значение и имя в sliderObserver
  };

  return (
    <div className={`${styles.container} ${props.stylesSlider}`}>
      <p className={styles.title}>{props.title}</p>
      {props.subtitle && (
        <span className={styles.subtitle}>{props.subtitle}</span>
      )}

      <span className={styles.value}>{value}</span>
      <input
        type="range"
        min={props.min}
        max={props.max}
        step={props.step}
        className={styles.radius}
        value={value}
        onChange={handlerOnInput}
      />
    </div>
  );
}